import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-sm-flex align-items-center" }, null, -1)
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, " Commande ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, " Montant total ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, " Client ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, " Paiement ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, " Livraison ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, " Livreur ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, " Statut ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
}, " Etape suivante ", -1)
const _hoisted_17 = {
  key: 0,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
}
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete icon-position" }, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = {
  key: 0,
  class: "badge-container"
}
const _hoisted_31 = { class: "col-6" }
const _hoisted_32 = { class: "badge badge-outline-danger text-outline-primary" }
const _hoisted_33 = {
  key: 1,
  class: "badge text-bg-danger rounded-pill fs-13"
}
const _hoisted_34 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_35 = {
  key: 0,
  class: "badge text-bg-success rounded-pill fs-13"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0"
}
const _hoisted_38 = { class: "dropdown" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_40 = { class: "dropdown-menu" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-fast-delivery lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_48 = {
  class: "modal fade createNewModal",
  id: "ObservationSuiviModal",
  tabindex: "-1",
  ref: "addObservationSuiviModalRef",
  "aria-hidden": "true"
}
const _hoisted_49 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_50 = { class: "modal-content p-15 p-md-40" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title fw-bold text-black" }, "Validation de l'étape")
], -1)
const _hoisted_52 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-md-12" }
const _hoisted_55 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Informations supplémentaires "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
  type: "submit"
}, " Envoyer ", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close shadow-none",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AffectationLivreurModal = _resolveComponent("AffectationLivreurModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher une commande"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _hoisted_5
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                _hoisted_12,
                _hoisted_13,
                _hoisted_14,
                _hoisted_15,
                _hoisted_16,
                (_ctx.checkPermission('AddCommande'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_17, " Action "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commandes, (commande, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_18, _toDisplayString(commande.refCommande), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(commande.montantTotal), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(commande?.client.nomComplet), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(commande?.moyenPaiement?.libelle), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(commande?.modeLivraison?.libelle), 1),
                  _createElementVNode("td", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commande?.users, (user, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: user.id
                      }, [
                        _createElementVNode("p", {
                          class: _normalizeClass({
                      'text-green': index === commande.users.length - 1,
                    })
                        }, [
                          _createElementVNode("span", _hoisted_24, [
                            _createTextVNode(_toDisplayString(user.nomComplet) + " ", 1),
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              class: "tag-delete-link text-outline-danger",
                              onClick: ($event: any) => (_ctx.suppressionZone(user.id, commande.id))
                            }, _hoisted_27, 8, _hoisted_25)
                          ])
                        ], 2)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("td", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      (
                      commande.suivicommandes &&
                      commande.suivicommandes.length > 0
                    )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.getLastStatus(commande).statutcommande.libelle), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_33, " Aucun suivi "))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_34, [
                    (_ctx.isLastStatus[commande.id])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, " Fin du suivi "))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "badge text-white bg-primary fs-15",
                          href: "#",
                          onClick: _withModifiers(($event: any) => (
                    _ctx.openEditModal(
                      commande.id,
                      _ctx.ordreL[commande.id],
                      _ctx.libelleL[commande.id]
                    )
                  ), ["prevent"])
                        }, _toDisplayString(_ctx.libelleL[commande.id]), 9, _hoisted_36))
                  ]),
                  (_ctx.checkPermission('AddCommande'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("ul", _hoisted_40, [
                            (_ctx.checkPermission('ViewCommande'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                                  _createVNode(_component_router_link, {
                                    to: {
                          name: 'ViewCommandePage',
                          params: { id: commande.id },
                        },
                                    class: "dropdown-item d-flex align-items-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_42,
                                      _createTextVNode("Détails")
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "#",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#AffectationLivreurModal",
                                onClick: ($event: any) => (_ctx.openAffectationLivreurModal(commande))
                              }, [
                                _hoisted_44,
                                (commande?.users?.length == 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, "Affecter un livreur"))
                                  : _createCommentVNode("", true),
                                (commande?.users?.length != 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_46, "Réaffecter un autre livreur"))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_43)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.observation) = $event)),
                      class: "form-control shadow-none rounded-0 text-black",
                      placeholder: "Ecrire le message"
                    }, null, 512), [
                      [_vModelText, _ctx.observation]
                    ])
                  ])
                ]),
                _hoisted_57
              ])
            ], 32)
          ]),
          _hoisted_58
        ])
      ])
    ], 512),
    _createVNode(_component_AffectationLivreurModal, {
      selectedCommande: _ctx.selectedCommande,
      selectedCommandeId: _ctx.selectedCommandeId,
      onClose: _ctx.recharger
    }, null, 8, ["selectedCommande", "selectedCommandeId", "onClose"])
  ], 64))
}